import { render, staticRenderFns } from "./DeactiveArticle.vue?vue&type=template&id=7bb9da0f&"
import script from "./DeactiveArticle.vue?vue&type=script&lang=js&"
export * from "./DeactiveArticle.vue?vue&type=script&lang=js&"
import style0 from "./DeactiveArticle.vue?vue&type=style&index=0&id=7bb9da0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports